import React, { useState, useEffect } from 'react'
import { connect } from "react-redux";
import { HideCheckboxOptions } from '../../assets/data/hideCheckboxOnCondition'
import { isEmpty, isString } from '../../helper/index'
import {useGlobalSpinnerActionsContext} from '../../context/GlobalSpinnerContext'
import {facilityMapping} from '../../assets/data/facilityOU'
import _ from 'lodash';
import {
    Button,
    ButtonStrip,
    InputFieldFF,
    SingleSelectFieldFF,
    ReactFinalForm,
    SwitchFieldFF,
    hasValue,
    TextAreaFieldFF,
    composeValidators,
    dhis2Username,
    FieldGroupFF,
    CheckboxFieldFF,
    FileInputFieldFF
} from '@dhis2/ui';

import {
    TextField,
    Checkboxes,
    Radios,

    TimePicker,
    Switches,
    KeyboardDatePicker,
    DatePicker,
    DateTimePicker,
    Autocomplete,

} from 'mui-rff';

import OUFieldConfig from './OUFieldConfig';

import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';


import { apiServices } from '../../services/apiServices';
import HideShowCondition from '../validation/HideShowConditionRegistration'
import AssignCondition from '../validation/AssignRegistration'
import ShowErrorRegistration from '../validation/showError/ShowErrorRegistration'

import Validator from '../validation/validator/Validator'

import Grid from '@material-ui/core/Grid';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';
import Geocode from "react-geocode";
import OUMapping  from '../../assets/data/registerOU'

import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import FormLabel from '@material-ui/core/FormLabel';

import { Checkbox as MuiCheckbox } from '@material-ui/core';

import SearchLocationInput from './SearchLocationInput'

import imgUrl from '../../assets/images/imageUrl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode, faTimes, faFileUpload } from "@fortawesome/free-solid-svg-icons";
import QrReader from 'react-qr-reader'
import OfflineDb from '../../db'
import { ta } from 'date-fns/locale';
import moment from 'moment'
//import { Configuration } from '../../assets/data/config'
const { Form, Field, FormSpy } = ReactFinalForm




const ValidatorComponent = (fieldId, attribute, values, form, rules, field) => {

    let programRules = rules.programRule
    let programRulesVariables = rules.programRuleVariable

    let filteringRuleWithField = null
    let Flag = null
    let val = null
    let conditionArray = []
    let programRuleActionType = null
    let hideShow = true
    let assign
    programRules.map(rules => {
        filteringRuleWithField = rules.programRuleActions.filter(obj => obj.trackedEntityAttribute ? fieldId == obj.trackedEntityAttribute.id : undefined)

        if (filteringRuleWithField.length > 0) {


            switch (filteringRuleWithField[0].programRuleActionType) {
                case 'HIDEFIELD':
                    hideShow = HideShowCondition(rules, programRulesVariables, values, field)
                    break;

                case 'ASSIGN':
                    assign = AssignCondition(
                        rules,
                        programRulesVariables,
                        values,
                        field,
                        fieldId,
                        attribute,
                        filteringRuleWithField

                    );
                    // <AssignCondition fieldId={fieldId} rules={rules} programRulesVariables={programRulesVariables} values={values} field={field} filteringRuleWithField={filteringRuleWithField}/>
                    break;

                // case 'SHOWERROR':

                //     programRuleActionType = ShowErrorRegistration(rules, programRulesVariables, values, field, fieldId, attribute)
                // break;
            }

        }
    })

    return ({
        'hideShow': hideShow,
        'assign': assign
    })

};

const getTranslatedLabels = (attribute) => {
    if (localStorage.getItem("locale") == "en") {
        return attribute.formName ? attribute.formName : attribute.description ? attribute.description : attribute.displayName ;
    } else if (attribute.translations && attribute.translations.length > 0) {
        //debugger;
        let label = attribute.translations.filter(tanslation => tanslation.property == "NAME" && tanslation.locale == localStorage.getItem("locale"))
        if (label.length > 0) {
            return label[0].value;
        } else {
            return  attribute.formName ?  attribute.formName : attribute.description ? attribute.description : attribute.displayName;
        }
    }
    return  attribute.formName ?  attribute.formName : attribute.description ? attribute.description : attribute.displayName;
};

function InputFieldConfig(props) {
    //console.log("props",props)
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let programData = props.programData,
    activeCaseDetails = props.activeCaseDetails,
    linkContactFlag = props.linkContactFlag,
    values = props.values,
    Configuration = props.Configuration;
    let indexClient = props.indexClient
    let customProps = {};
    let customVariable = props.customVariable
    let userBO = props.userBO
    const setGlobalSpinner = useGlobalSpinnerActionsContext()
    const [fieldType, setFieldType] = useState(null)
    const [optionSet, setOptions] = useState(null)
    const [icons, setIcons] = useState(null)
    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)
    const [hideFieldAttr, setHideFieldAttr] = useState(false)
    //=========custom logic for UNDP==================
    const [PresentlyOnAntiTBMedicationId, setPresentlyOnAntiTBMedicationId] = useState(null)
    const [clientTypeID, setClientTypeID] = useState(null)
    const [verifiedFieldId, setVerifiedFieldId] = useState(null)
    function getCustomVariableIds(){
        programData.programTrackedEntityAttributes.map(regField => {
            let fieldName = regField.trackedEntityAttribute.description ? regField.trackedEntityAttribute.description : regField.trackedEntityAttribute.formName ? regField.trackedEntityAttribute.formName : regField.trackedEntityAttribute.displayName
            if(fieldName.trim().toLocaleLowerCase() == "client type"){
                setClientTypeID(regField.trackedEntityAttribute.id)
            }
            if(fieldName.trim().toLocaleLowerCase() == "presently on anti-tb medication?" || fieldName.trim().toLocaleLowerCase() == "are you currently on tb treatment?"){
                setPresentlyOnAntiTBMedicationId(regField.trackedEntityAttribute.id)
            }
            if(fieldName.trim().toLocaleLowerCase() == "documents verified"){
                setVerifiedFieldId(regField.trackedEntityAttribute.id)
            }
        })
        if(fieldData.trackedEntityAttribute.attributeValues && fieldData.trackedEntityAttribute.attributeValues.length > 0){
            fieldData.trackedEntityAttribute.attributeValues.map((val) => {
                if (val.attribute.displayName === "hideField") {
                    setHideFieldAttr(true)
                }
            })
        }
    }
    const setClientTypeDropdwonValues = ()=>{
        if(!values[clientTypeID] && !indexClient){
            values[clientTypeID] = Configuration.ltbiLinkVariables.contact;
        }else if(indexClient){
            values[clientTypeID] = Configuration.ltbiLinkVariables.index;
        }else if(values[clientTypeID] == Configuration.ltbiLinkVariables.index && !indexClient){
            values[clientTypeID] = Configuration.ltbiLinkVariables.contact;
        }

        /*if(values[PresentlyOnAntiTBMedicationId] != undefined && values[PresentlyOnAntiTBMedicationId] == 'Yes'){
            values[clientTypeID] = Configuration.ltbiLinkVariables.index
        }*/
        /*if(activeCaseDetails && activeCaseDetails.data && values[clientTypeID] && values[PresentlyOnAntiTBMedicationId] == 'Yes'){
            values[clientTypeID] = Configuration.ltbiLinkVariables.index;
        }else if(values[PresentlyOnAntiTBMedicationId] != undefined && values[PresentlyOnAntiTBMedicationId] == 'Yes'){
            values[clientTypeID] = Configuration.ltbiLinkVariables.index
        }else if(linkContactFlag && linkContactFlag.data && linkContactFlag.data.enabled){
            values[clientTypeID] = Configuration.ltbiLinkVariables.contact;
        }
        else if(activeCaseDetails && activeCaseDetails.data && values[clientTypeID] == Configuration.ltbiLinkVariables.contact){
            values[clientTypeID] = Configuration.ltbiLinkVariables.contact;
        }else if(activeCaseDetails && activeCaseDetails.data && values[clientTypeID] == Configuration.ltbiLinkVariables.presumptivetb){
            values[clientTypeID] = Configuration.ltbiLinkVariables.presumptivetb;
        }else if(indexClient){
            values[clientTypeID] = Configuration.ltbiLinkVariables.index;
        }else if(values[clientTypeID] != Configuration.ltbiLinkVariables.contact){
            values[clientTypeID] = Configuration.ltbiLinkVariables.contact;
        }else if(activeCaseDetails && activeCaseDetails.data){
            //use default values coming for edit
        }
        customProps = {
        ...customProps,
        key: Math.random() * 9999,
        };*/
    }
    //End

    const required = value => (fieldData.mandatory && validationResult.hideShow == true ? value ? undefined : 'Required' : undefined)
    const scriptCheck = value => (value && value != undefined && value != null && value != '' ? value.match(/<[^>]*>/g) != null ? 'Incorrect expression "< or >" added as input' : undefined : undefined)
    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    function checkHideOptionsFields(attributes, programRules, programRulesVariables, values) {
        const fieldId = attributes.trackedEntityAttribute.id;
        let option = [];
        let filteringRuleWithField = null;

        programRules.map((rules) => {
            filteringRuleWithField = rules.programRuleActions.filter((obj) =>
                obj.trackedEntityAttribute ? fieldId == obj.trackedEntityAttribute.id : undefined
            );

            if (
                filteringRuleWithField.length > 0 &&
                filteringRuleWithField[0].programRuleActionType == "HIDEOPTION"
            ) {
                const operators = ["==", "!="];
                const condition = rules.condition;
                const splitConditions = condition.split("&&");
                let Flag = null;
                let val = null;
                let conditionArray = [];
                splitConditions.map((splitCondition) => {
                    const variableName = splitCondition.match(/\{(.*?)\}/)[1];
                    const parentRaw = programRulesVariables.filter(
                        (obj) => obj.displayName == splitCondition.match(/\{(.*?)\}/)[1]
                    ); //[0] .dataElement.id
                    const parentNameFromFilter =
                        parentRaw.length > 0 ? parentRaw[0].displayName : undefined;
                    const parentId =
                        parentRaw.length > 0
                            ? parentRaw[0].dataElement
                                ? parentRaw[0].dataElement.id
                                : parentRaw[0].trackedEntityAttribute
                                    ? parentRaw[0].trackedEntityAttribute.id
                                    : undefined
                            : undefined;

                    const parentNameFromFilterStart = splitCondition.search(
                        parentNameFromFilter
                    );
                    const parentNameLength = parentNameFromFilter
                        ? parentNameFromFilter.length
                        : undefined;

                    const operatorInitLength =
                        parentNameFromFilterStart + parentNameLength + 2;

                    const operator = splitCondition.substring(
                        operatorInitLength,
                        operatorInitLength + 2
                    );

                    const alternateOperatorFinding = operators.map((ops) => {
                        if (splitCondition.search(ops) > -1) {
                            const a = {
                                operator: ops,
                                operatorLength: splitCondition.search(ops),
                            };
                            return a;
                        }
                    });
                    const stringLength = splitCondition.length;
                    if (parentNameFromFilter) {
                        const filteredOperator = alternateOperatorFinding.filter(
                            (obj) => obj != undefined
                        );

                        const conditionValueRaw =
                            filteredOperator.length > 0
                                ? splitCondition.substring(
                                    filteredOperator[0].operatorLength + 3,
                                    splitCondition.length
                                )
                                : undefined;

                        const removeEmptySpace =
                            conditionValueRaw != undefined
                                ? conditionValueRaw.substring(
                                    conditionValueRaw.length - 1,
                                    conditionValueRaw.length
                                ) == " "
                                    ? conditionValueRaw.substring(0, conditionValueRaw.length - 1)
                                    : conditionValueRaw
                                : undefined;

                        const conditionValue =
                            removeEmptySpace != undefined
                                ? removeEmptySpace.substring(1, removeEmptySpace.length - 1)
                                : undefined;
                        const conditionalOperator =
                            filteredOperator.length > 0
                                ? filteredOperator[0].operator
                                : undefined;
                        let conditionForValidation = null;
                        if (conditionalOperator != undefined) {
                            val = conditionValue;
                            switch (conditionalOperator) {
                                case "==":
                                    if (
                                        values[parentId] != undefined &&
                                        String(values[parentId]) == String(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.trackedEntityAttribute.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        if (option.length > 0) {
                                                            let checkOptionInArray = option.find(obj => obj.id == options.id)
                                                            if(checkOptionInArray == undefined) {
                                                                option.push(options);
                                                            }
                                                    
                                                        } else {
                                                            option.push(options);
                                                        }
                                                        
                                                        
                                                        
                                                    } else {
                                                        // values[fieldId] = ''
                                                    
                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                    
                                                        let checkOptionInArray = option.find(obj => obj.id == temp.id)
                                                    
                                                        if(checkOptionInArray == undefined) {
                                                            option.push(temp);
                                                        }
                                                        
                                                        
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;

                                case ">=":
                                    if (
                                        values[parentId] != undefined &&
                                        Number(values[parentId]) >= Number(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.trackedEntityAttribute.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        option.push(options);
                                                    } else {
                                                        // values[fieldId] = ''

                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                        option.push(temp);
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;

                                case "<=":
                                    if (
                                        values[parentId] != undefined &&
                                        Number(values[parentId]) <= Number(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.trackedEntityAttribute.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        option.push(options);
                                                    } else {
                                                        // values[fieldId] = ''

                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                        option.push(temp);
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;

                                case "<":
                                    if (
                                        values[parentId] != undefined &&
                                        Number(values[parentId]) < Number(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.trackedEntityAttribute.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        option.push(options);
                                                    } else {
                                                        // values[fieldId] = ''

                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                        option.push(temp);
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;

                                case ">":
                                    if (
                                        values[parentId] != undefined &&
                                        Number(values[parentId]) > Number(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.trackedEntityAttribute.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        option.push(options);
                                                    } else {
                                                        // values[fieldId] = ''

                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                        option.push(temp);
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;
                            }
                        } else {
                            // values[parentId] != ''
                            // values[fieldId] = ''
                        }
                    }
                });
            }
        });
        if (option.length > 0) {
            return option;
        } else {
            return attributes.trackedEntityAttribute.optionSet.options
        }
    }

    function findFieldType() {
        const trackedEntityAttribute = fieldData.trackedEntityAttribute
        if (trackedEntityAttribute.optionSet != undefined) {
            if (fieldData.renderOptionsAsRadio) {
                setFieldType('radio')
            } else {
                if (fieldData.renderType) {
                    if (fieldData.renderType.DESKTOP) {
                        if (fieldData.renderType.DESKTOP.type == "ICONS_AS_BUTTONS") {
                            setFieldType('radio')
                        } else {
                            setFieldType('dropdown')
                        }
                    }
                }
            }
        } else {
            setFieldType('text')
        }
    }

    function fetchOption() {
        let output = []
        const trackedEntityAttribute = fieldData.trackedEntityAttribute
        
        if (trackedEntityAttribute.optionSet != undefined) {
            let refinedOptionList = checkHideOptionsFields(fieldData, programRules, programRulesVariables, values);
            let customValidation = false;
            if (trackedEntityAttribute.id == clientTypeID) {
                if(!indexClient){
                    refinedOptionList = [];
                    customValidation = true;
                    fieldData.trackedEntityAttribute.optionSet.options.find((o) => {
                    if (o.displayName != Configuration.ltbiLinkVariables.index) {
                      refinedOptionList.push(o);
                    } else {
                      refinedOptionList.push({
                        ...o,
                        displayName: "index"//"option not selected",
                      });
                    }
                  });
                }else if(indexClient){
                    refinedOptionList = [];
                    customValidation = true;
                    fieldData.trackedEntityAttribute.optionSet.options.find((o) => {
                        if (o.displayName == Configuration.ltbiLinkVariables.index) {
                          refinedOptionList.push(o);
                        } else {
                          refinedOptionList.push({
                            ...o,
                            displayName: "option not selected",
                          });
                        }
                      });
                }
            }
            if (trackedEntityAttribute.id == customVariable.hivStatusId) {
                if(values && values[clientTypeID] && values[clientTypeID] == "Person living with HIV"){
                    fieldData.trackedEntityAttribute.optionSet.options.find((o) => {
                        if (o.code == "Reactive") {
                            values[customVariable.hivStatusId] = o.code
                        } 
                      });
                }
            }
            //dataElement.optionSet.options.map((items, index) => {
            refinedOptionList.map((items, index) => {    
                if (icons.length > 0) {
                    if (customValidation) {
                        output.push({
                            value: items.code,
                            label: items.displayName,
                          });
                    }else {
                        output.push({
                          value: items.code,
                          label: (
                            <>
                              {" "}
                              <span
                                dangerouslySetInnerHTML={{ __html: icons[index] }}
                              />{" "}
                              <>{getTranslatedLabels(items)} </>{" "}
                            </>
                          ),
                        });
                      }
                } else {
                    output.push({ value: items.code, label: getTranslatedLabels(items) });
                }
            })

        }
        // if(trackedEntityAttribute.id == clientTypeID){
        //     console.log("output ",output);
        // }
        if (output.length > 0) {
            setOptions(output)
        }
    }

    function getIcons() {
        let promises = [];
        const trackedEntityAttribute = fieldData.trackedEntityAttribute
        if(navigator.onLine){
            if (trackedEntityAttribute.optionSet != undefined) {
                trackedEntityAttribute.optionSet.options.forEach((options) => {
                    if (options.style != undefined) {
    
                        const getIconApi = 'icons/' + options.style.icon + '/icon.svg'
                        promises.push(apiServices.getAPI(getIconApi))
                    } else {
                        promises.push({})
                    }
                })
    
                Promise.all(promises).then((responses) => {
    
                    const icons = responses.map((response) => response.data)
    
                    if (icons.length > 0) {
                        setIcons(icons)
                    } else {
                        setIcons([])
                    }
                })
            } else {
                setIcons([])
            }
        }else{
            setIcons([])
        }
        

    }

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }
    
    useEffect(() => {
        getIcons()
        getCustomVariableIds()
    }, [])
    useEffect(() => {
        if(clientTypeID != null){
            setClientTypeDropdwonValues()
        }
    })
    useEffect(() => {
        if (Array.isArray(icons)) {
            findFieldType()
            fetchOption()
            fetchValidation()
        }

    }, [icons,values])

    useEffect(() => {
        
        if (validationResult != null && fieldType != null) {
            if(fieldData.trackedEntityAttribute.id == clientTypeID || fieldData.trackedEntityAttribute.id == PresentlyOnAntiTBMedicationId){
                customProps = {
                    ...customProps,
                    key: Math.random() * 9999,
                    };
            }
            if(fieldData.trackedEntityAttribute.id == PresentlyOnAntiTBMedicationId && indexClient){
                customProps = {
                    ...customProps,
                    className: 'hide',
                    };
            }
            if(fieldData.trackedEntityAttribute.id == customVariable.regRegisteredById){
                if(userBO && userBO.userCredentials){
                    values[fieldData.trackedEntityAttribute.id] = userBO.userCredentials.username
                }
                validationResult.hideShow = false
            }
            if(values && values[clientTypeID] && values[clientTypeID] == "Person living with HIV"){
                //values[customVariable.hivStatusId] = "Reactive1"
            }
            if (fieldType == "text") {
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true && !hideFieldAttr ? '' : 'hide'}>
                        <Field
                            name={fieldData.trackedEntityAttribute.id}
                            label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                            type={'text'}
                            component={InputFieldFF}
                            key={fieldData.trackedEntityAttribute.id}
                            required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                            validate={composeValidators(required, scriptCheck)} //fieldData.mandatory && validationResult.hideShow == true ? hasValue : false
                            value=''

                        />
                    </Grid>
                )
            } else if (fieldType == "radio") {
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                        <Radios
                            id={fieldData.trackedEntityAttribute.id}
                            label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                            name={fieldData.trackedEntityAttribute.id}
                            required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                            data={optionSet != null ? optionSet : []}
                        // defaultValue={defaultValue}
                        />
                    </Grid>
                )

            } else if (fieldType == "dropdown") {
                try{
                    if (values[fieldData.trackedEntityAttribute.id]) {
                        let isValueExist = true;
                        isValueExist = optionSet.find(
                            (obj) => obj.value == values[fieldData.trackedEntityAttribute.id]
                        );
                        if (isValueExist == undefined) {
                            delete values[fieldData.trackedEntityAttribute.id]
                        }
                    }
                }catch(e){

                }
                if(validationResult.hideShow == true) {
                    setFieldStructure(
                        <Grid item xs={12} sm={4} md={4} {...customProps} >
                            <Field
                                id={fieldData.trackedEntityAttribute.id}
                                name={fieldData.trackedEntityAttribute.id}
                                label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                                // type={fieldData.trackedEntityAttribute.valueType}
    
                                component={SingleSelectFieldFF}
                                key={fieldData.trackedEntityAttribute.id}
                                validate= {fieldData.mandatory && validationResult.hideShow == true ? hasValue: false}
                                required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                                options={optionSet != null ? optionSet : []}
                                disabled={fieldData.trackedEntityAttribute.attributeValues && fieldData.trackedEntityAttribute.attributeValues.length > 0 ? fieldData.trackedEntityAttribute.attributeValues[0].attribute.name == 'isDisabled' ? true : false : false}
                                //onChange={() => onDropdownOptionChange}
                                {...customProps}
                            />
                        </Grid>
                    )
                }  else {
                    setFieldStructure(
                        <Grid item xs={12} sm={4} md={4} className={'hide'}>
                            <Field
                            name={fieldData.trackedEntityAttribute.id}
                            label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                            type={'text'}
                            component={InputFieldFF}
                            key={fieldData.trackedEntityAttribute.id}
                            required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                            options={optionSet != null ? optionSet : []}
                            disabled={fieldData.trackedEntityAttribute.attributeValues && fieldData.trackedEntityAttribute.attributeValues.length > 0 ? fieldData.trackedEntityAttribute.attributeValues[0].attribute.name == 'isDisabled' ? true : false : false}
                            //onChange={() => onDropdownOptionChange}
                            validate={composeValidators(required, scriptCheck)} //fieldData.mandatory && validationResult.hideShow == true ? hasValue : false
                            value=''
                        />
                        </Grid>
                    )
                } 
                
            }
        }


    }, [fieldType, optionSet, validationResult])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function DateFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let showYear = fieldData.trackedEntityAttribute.attributeValues.length > 0 && fieldData.trackedEntityAttribute.attributeValues[0].attribute.name == "showyear" ? true : false
    const [fieldStructure, setFieldStructure] = useState(null)
    const [selectedDate, setDate] = useState(new Date());
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            if (!values[fieldData.trackedEntityAttribute.id]) {
                values[fieldData.trackedEntityAttribute.id] = selectedDate;
            }
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <DatePicker

                        disabled={showYear ? true : false}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        name={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        dateFunsUtils={DateFnsUtils}
                        value={values[fieldData.trackedEntityAttribute.id] == undefined ? selectedDate : values[fieldData.trackedEntityAttribute.id]}
                        margin="normal"
                        variant="inline"
                        format={showYear == true ? "yyyy" : "yyyy-MM-dd"}
                        validate={selectedDate.mandatory && validationResult.hideShow == true ? hasValue : false}
                        disableFuture={fieldData.allowFutureDate ? fieldData.allowFutureDate : false}
                    />
                </Grid>
            )
        }

    }, [validationResult])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )

}

function DateTimeFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let showYear = fieldData.trackedEntityAttribute.attributeValues.length > 0 && fieldData.trackedEntityAttribute.attributeValues[0].attribute.name == "showyear" ? true : false
    const [fieldStructure, setFieldStructure] = useState(null)
    const [selectedDate, setDate] = useState(new Date());
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <DateTimePicker
                        disabled={showYear ? true : false}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        name={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        dateFunsUtils={DateFnsUtils}
                        value={values[fieldData.trackedEntityAttribute.id] == undefined ? selectedDate : values[fieldData.trackedEntityAttribute.id]}
                        margin="normal"
                        variant="inline"
                        format={showYear == true ? "yyyy" : "yyyy-MM-dd"}
                        validate={selectedDate.mandatory && validationResult.hideShow == true ? hasValue : false}
                        disableFuture={fieldData.allowFutureDate ? fieldData.allowFutureDate : false}
                    />
                </Grid>
            )
        }

    }, [validationResult])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )

}

function AgeFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values

    const required = value => (fieldData.mandatory && validationResult.hideShow == true ? value ? undefined : 'Required' : undefined)
    const mustBeNumber = value => (isNaN(value) && value ? 'Must be a number' : undefined)
    const minValue = min => value =>
        isNaN(value) || value >= min ? undefined : `Should be greater than ${min}`
    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.trackedEntityAttribute.id}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        type="number"
                        component={InputFieldFF}
                        key={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, mustBeNumber)}
                    />
                </Grid>
            )
        }

    }, [validationResult])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function PhoneNumberFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values

    const numberFormat = value =>
        isNaN(value) && value ? `Incorrect format` : undefined

    const maxLength = max => value => value ? isNaN(value) || value.length > max ? `Should be less than ${max}` : undefined : undefined
    const required = value => (fieldData.mandatory && validationResult.hideShow == true ? value ? undefined : 'Required' : undefined)

    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.trackedEntityAttribute.id}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        type={'number'}
                        component={InputFieldFF}
                        key={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, numberFormat, maxLength(12))}
                    />
                </Grid>
            )
        }

    }, [validationResult])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function EmailFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values

    const EMAIL_ADDRESS_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i

    const invalidEmailMessage = 'Please provide a valid email address'

    const email = value =>
        isEmpty(value) || (isString(value) && EMAIL_ADDRESS_PATTERN.test(value))
            ? undefined
            : invalidEmailMessage

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.trackedEntityAttribute.id}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        type={'email'}
                        component={InputFieldFF}
                        key={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        validate={email}

                    />
                </Grid>
            )
        }

    }, [validationResult])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function DefaultValueField(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let linkContactFlag= props.linkContactFlag
    const setGlobalSpinner = useGlobalSpinnerActionsContext()
    const [UIC, setUIC] = useState(null)

    function getUIC() {
        if(navigator.onLine && UIC == null){
            setGlobalSpinner(true)
            apiServices.generateUIC(fieldData.trackedEntityAttribute.id)
            .then(response => {
                setUIC(response.value)
                setGlobalSpinner(false)
            }).catch(err=>{
                setGlobalSpinner(false)
            })
        }else{
            OfflineDb.getDataFromPouchDB('offlineUICList').then(res=>{
                let uicobj = res.data.pop();
                setUIC(uicobj.value)
                OfflineDb.setDataIntoPouchDB('offlineUICList', res.data);
            })
        }
        
        
    }
    useEffect(() => {
        getUIC()
    }, [linkContactFlag])

    return (
        <>
            {UIC != null ?
                <Grid item xs={12} sm={4} md={4}>
                    <Field
                        name={fieldData.trackedEntityAttribute.id}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        type={fieldData.trackedEntityAttribute.valueType}
                        component={InputFieldFF}
                        key={fieldData.trackedEntityAttribute.id}
                        defaultValue={UIC}
                        disabled={true}
                    />
                </Grid>
                :
                <> </>
            }
        </>
    )
}

function BooleanFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    const switchData = [
        { label: 'Yes', value: 'item1' },
    ];

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Switches
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        name={fieldData.trackedEntityAttribute.id}
                        disableRipple
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        data={switchData}
                    />
                </Grid>
            )
        }

    }, [validationResult])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function TimeFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let showYear = fieldData.trackedEntityAttribute.attributeValues.length > 0 && fieldData.trackedEntityAttribute.attributeValues[0].attribute.name == "showyear" ? true : false
    const [fieldStructure, setFieldStructure] = useState(null)
    const [selectedDate, setDate] = useState(new Date());
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <TimePicker
                        label={fieldData.trackedEntityAttribute.displayFormName}
                        name={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        dateFunsUtils={DateFnsUtils}
                        margin="normal"
                        variant="inline"
                        format="HH:MM"
                    />
                </Grid>
            )
        }

    }, [validationResult])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )

}

function IntegerConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customVariables = props.customVariable

    const required = value => (fieldData.mandatory && validationResult.hideShow == true ? value ? undefined : 'Required' : undefined)
    const mustBeNumber = value => (isNaN(value) && value ? 'Must be a number' : undefined)
    const minValue = min => value =>
        isNaN(value) || value >= min ? undefined : `Should be greater than ${min}`

    const maxValue = max => value =>
        isNaN(value) || value <= max ? undefined : `Should be less than ${max}`


    const errorCheck = value => (value ? findError(value): undefined)
    
    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)        
    }

    function findError (value) {
        let latestValidationValue = {}
        latestValidationValue[fieldData.trackedEntityAttribute.id] = value

        let fetchValidationDetails = Validator(fieldData.trackedEntityAttribute.id, fieldData, latestValidationValue, programRules, programRulesVariables)
        return fetchValidationDetails.showError ? fetchValidationDetails.showError : undefined
    }

    function calculateAge(selectedDate) {
        let dt2 = new Date(selectedDate);
        let dt1 = new Date();
    
        var a = moment(dt2);
        var b = moment(dt1);
    
        var years = a.diff(b, "years");
        var birth = Math.abs(years);
        var age = Math.abs(years);
        if(age == 0){
            age = "0"
        }
        console.log("years", age);
        return age;
      }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            let fieldDisabled = false;
            let customProps = {};
            if (fieldData.trackedEntityAttribute.id == customVariables.ageId && values[customVariables.dateOfBirthId]) {
                values[fieldData.trackedEntityAttribute.id] = calculateAge(values[customVariables.dateOfBirthId])
                if(values[fieldData.trackedEntityAttribute.id]){
                    fieldDisabled = true;
                }
            }
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.trackedEntityAttribute.id}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        type={'number'}
                        component={InputFieldFF}
                        key={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, mustBeNumber, minValue(0), errorCheck)}
                        value=''
                        disabled={fieldDisabled ? true : false}
                        //{...customProps}
                    />
                </Grid>
            )
        }

    }, [validationResult])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function TextAreaConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    const required = value => (fieldData.mandatory && validationResult.hideShow == true ? value ? undefined : 'Required' : undefined)
    const scriptCheck = value => (value ? value.match(/<[^>]*>/g) != null ? 'Incorrect expression "< or >" added as input' : undefined : undefined)
    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.trackedEntityAttribute.id}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        type={'text'}
                        component={InputFieldFF}
                        key={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, scriptCheck)}
                        autoGrow
                    />
                </Grid>
            )
        }

    }, [validationResult])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function UserNameConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.trackedEntityAttribute.id}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        component={TextAreaFieldFF}
                        key={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(hasValue, dhis2Username)}
                    />
                </Grid>
            )
        }

    }, [validationResult])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function URLConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    const required = value => (fieldData.mandatory && validationResult.hideShow == true ? value ? undefined : 'Required' : undefined)

    const URLCheck = value => (regexp.test(value) ? undefined : 'Incorrect URL format')

    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.trackedEntityAttribute.id}
                        label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                        component={TextAreaFieldFF}
                        key={fieldData.trackedEntityAttribute.id}
                        required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, URLCheck)}
                    />
                </Grid>
            )
        }

    }, [validationResult])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function HandleOUOptions(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let OUMappingList = OUMapping(values)   
    let parentValue = OUMappingList[fieldData.trackedEntityAttribute.id] != undefined ? values[OUMappingList[fieldData.trackedEntityAttribute.id].parent] : null
    let programData = props.programData
    let options= props.options
    let defaultOption= props.defaultOption
    let rules = {
       "programRule": props.programRules,
       "programRuleVariable":props.programRulesVariables
    }
    let OUJSON = props.OUJSON.organisationUnits
    if(fieldData.trackedEntityAttribute.displayName == "Facility address"){
        OUJSON = OUJSON.filter(obj => obj.comment == "Facility")
    }

    const option = { "id": "option1", "label": 'Option1', "value": 'option1' }

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)
    const [location, setLocation] = useState([])
    const setGlobalSpinner = useGlobalSpinnerActionsContext()

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        
        
        
        if(options != '') {
            let locationList = []
            //setGlobalSpinner(true)
            const filterOnId = OUJSON.filter(obj => obj.id == options)
            if(filterOnId.length > 0 && fieldData.trackedEntityAttribute.displayName != "Facility address") {
                const childrenOptions = filterOnId[0].children
                childrenOptions.map(childOptions => {
                    const filterChildDetails = OUJSON.filter(obj => obj.id == childOptions.id)
                    if(filterChildDetails.length > 0) {
                        let obj = {
                            'id': filterChildDetails[0].id,
                            'label': filterChildDetails[0].name,
                            'value': filterChildDetails[0].id,
                        }
                        locationList.push(obj)
                        setLocation(locationList)
                    }
                    
                })
                
            }
            if(fieldData.trackedEntityAttribute.displayName == "Facility address"){
                OUJSON.map(facility=>{
                    let obj = {
                        'id': facility["id"],
                        'label': facility["name"],
                        'value': facility["id"],
                    }
                    locationList.push(obj)
                    locationList = _.orderBy(locationList, ['label'],['asc'])
                    setLocation(locationList)
                })
            }
        } else {
            const OUList = programData.organisationUnits
            let autocompleteData = []
            
            if (OUMappingList[fieldData.trackedEntityAttribute.id] != undefined && fieldData.trackedEntityAttribute.displayName != "Facility address") {
                if (OUMappingList[fieldData.trackedEntityAttribute.id].type) {
                    
                    let OUOptions = OUJSON.filter(obj => obj.level == OUMappingList[fieldData.trackedEntityAttribute.id].level)
                    if(OUOptions.length > 0) {
                        OUOptions.map(items => {
                            let obj = {
                                'id': items.id , 
                                'label': items.name, 
                                'value': items.id
                            }
                            autocompleteData.push(obj)
                        })
                        setLocation(autocompleteData)
                    }
                }
            }
            if(fieldData.trackedEntityAttribute.displayName == "Facility address"){
                OUJSON.map(facility=>{
                    let obj = {
                        'id': facility["id"],
                        'label': facility["name"],
                        'value': facility["id"],
                    }
                    autocompleteData.push(obj)
                    autocompleteData = _.orderBy(autocompleteData, ['label'],['asc'])
                    setLocation(autocompleteData)
                })
            }

        }
        
    }, [values[fieldData.trackedEntityAttribute.id], parentValue, options]) //defaultOption, options

    useEffect(() => {
            if(location != null) {
                if(values[fieldData.trackedEntityAttribute.id]) {
                    if(!_.isEmpty(defaultOption)) {
                        setFieldStructure(
                            <OUFieldConfig 
                                data={fieldData} values={values} rules={rules} options={location} defaultOption={defaultOption} programData={programData} OUMapping={OUMappingList}
                            />
                        )
                    }
                }else {
                    setFieldStructure(
                        <OUFieldConfig 
                            data={fieldData} values={values} rules={rules} options={location} defaultOption={defaultOption} programData={programData} OUMapping={OUMappingList}
                        />
                    )
                }
            }
            
        
    }, [location])
    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function MultiSelectConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    //let DataElementGroup = DataElementGroup
    let DataElementGroup = props.DataElementGroup
    let programObj = props.programObj
    let customVariable = props.customVariable
    let customProps = {};

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    function getFieldDetails(fieldId, formValues) {
        const getFieldsAttributes = programObj.programTrackedEntityAttributes.filter(
            (obj) => obj.trackedEntityAttribute.id == fieldId
        );

        if (getFieldsAttributes.length > 0) {

            const fieldData1 = getFieldsAttributes[0];

            const findField = HideCheckboxOptions[fieldData1.trackedEntityAttribute.id]
            let isFieldDisbaled = false
            if (findField != undefined) {
                
                findField.field.map(eachField => {
                    if (formValues[eachField] == findField.value) {
                        isFieldDisbaled = true
                    }
                })


            }
            //console.log("values ",values,props.DataElementGroup.id);
            try{
                if(values && values[props.DataElementGroup.id]){
                    values[props.DataElementGroup.id].map((field) => {
                        values[field] = true
                    })
                }
            }catch(e){
                console.log(e);
            }
            return (
                <Field
                    type="checkbox"
                    component={CheckboxFieldFF}
                    name={props.DataElementGroup.id}
                    disabled={isFieldDisbaled}
                    label={getTranslatedLabels(fieldData1.trackedEntityAttribute)}
                    value={fieldData1.trackedEntityAttribute.id}
                />
            );
        }
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            if(values && values[customVariable.clientTypeID] && values[customVariable.clientTypeID] != "Others"){
                //values[customVariable.hivStatusId] = "Reactive1"
                customProps = {
                ...customProps,
                className: 'hide',
                };
            }
            setFieldStructure(
                <Grid item xs={12} sm={4} className={validationResult.hideShow == true ? 'customLoc' : 'hide'} {...customProps}>
                    <FieldGroupFF
                        label={getTranslatedLabels(DataElementGroup)}
                        // onClick={(e, v) => onChange(e, v)}
                        name={DataElementGroup.id}
                    >
                        {DataElementGroup.trackedEntityAttributes.map((field) => {
                            return getFieldDetails(field.id, values);
                        })}
                    </FieldGroupFF>
                </Grid>
            )
        }

    }, [validationResult])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )

}

function QrCodeScanner(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values

    const [fieldStructure, setFieldStructure] = useState(null)
    const [showScannner, setShowScannner] = useState(false)
    const [defaultValue, setDefaultValue] = useState(null)
    
    function qrErrorhandler() {
        setShowScannner(false)
    }

    function handleQRScan(data) {
        if (data) {
            setShowScannner(false)
            setDefaultValue(data)
        }
    }

    function closeQrSacnner() {
        setShowScannner(false)
    }
    function openCordovaQrScanner (){
        let that = this;
        window.cordova.plugins.barcodeScanner.scan(
            function (result) {
                
                handleQRScan(result.text);
            },
            function (error) {
                
            },
            {
                preferFrontCamera: false, // iOS and Android
                showFlipCameraButton: true, // iOS and Android
                showTorchButton: false, // iOS and Android
                torchOn: false, // Android, launch with the torch switched on (if available)
                prompt: 'Place a barcode inside the scan area', // Android
                resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
                //formats : "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
                //orientation : "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
                disableAnimations: true, // iOS
                disableSuccessBeep: false // iOS
            }
         );    
    }
    function openQrSacnner () {
        if(window.cordova){
            openCordovaQrScanner()
        }else{
            setShowScannner(true)
        }
    }
    
    useEffect(() => {
        if(defaultValue!=null){
            values[fieldData.trackedEntityAttribute.id] = defaultValue
        }
        if(showScannner) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} >
                    <div style={{ display: 'none' }}>
                        <Field
                            name={fieldData.trackedEntityAttribute.id}
                            label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                            type={fieldData.trackedEntityAttribute.valueType}
                            component={InputFieldFF}
                            key={fieldData.trackedEntityAttribute.id}
                            defaultValue={defaultValue}
                        />
                    </div>
                    <div>
                        <QrReader
                            delay={300}
                            onError={qrErrorhandler}
                            onScan={handleQRScan}
                            style={{ width: '50%', cursor: 'pointer' }}
                        />
                        <span onClick={() =>closeQrSacnner()}><FontAwesomeIcon icon={faTimes} /></span>
                    </div>
                </Grid>
            )
        } else {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} >
                    <div style={{ display: 'none' }}>
                        <Field
                            name={fieldData.trackedEntityAttribute.id}
                            label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                            type={fieldData.trackedEntityAttribute.valueType}
                            component={InputFieldFF}
                            key={fieldData.trackedEntityAttribute.id}
                            defaultValue={defaultValue}
                        />
                    </div>
                    <p className="qrIcon" onClick={() => openQrSacnner()}><FontAwesomeIcon className="fa-3x" icon={faQrcode} /></p>
                </Grid>
            )
        }
    }, [showScannner,defaultValue])


    return (
        <>
            {
                fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function ImageFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let dataElementGroup = props.dataElementGroup

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)
    const [defaultValue, setDefaultValue] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    async function openFileChooser(){
        console.log("openFileChooser")
        const file = await window.chooser.getFile();
        console.log(file);
        setDefaultValue(file)
    }
    useEffect(() => {
        
        if (validationResult != null) {
            if(window.cordova && !navigator.onLine){
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                        <div style={{ display: 'none' }}>
                            <Field
                                name={fieldData.trackedEntityAttribute.id}
                                label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                                type={fieldData.trackedEntityAttribute.valueType}
                                component={InputFieldFF}
                                key={fieldData.trackedEntityAttribute.id}
                                defaultValue={defaultValue}
                            />
                        </div>
                        <label>{getTranslatedLabels(fieldData.trackedEntityAttribute)}</label>
                        <p className="qrIcon" onClick={() => openFileChooser()}><FontAwesomeIcon className="fa-3x" icon={faFileUpload} /></p>
    
                    </Grid>
                    
                )
            }else{
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                        {/* <DropzoneArea
                            name={fieldData.trackedEntityAttribute.id}
                            onChange={handleChange.bind(this)}
                            filesLimit={1}
                        /> */}
    
                        <Field
                            name={fieldData.trackedEntityAttribute.id}
                            label={getTranslatedLabels(fieldData.dataElement)}
                            component={FileInputFieldFF}
                            key={fieldData.trackedEntityAttribute.id}
                            required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                            value={[]}
                            //onChange={handleChange.bind(this)}
                            //validate={composeValidators(required, URLCheck)}
                        />
    
                    </Grid>
                )
            }
            
        }

    }, [validationResult,defaultValue])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function GoogleLocation(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    const required = value => (fieldData.mandatory && validationResult.hideShow == true ? value ? undefined : 'Required' : undefined)

    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)
    const [placeholder, setPlaceholder] = useState(values[fieldData.trackedEntityAttribute.id] ? values[fieldData.trackedEntityAttribute.id] : null)
    //const [value, setValue] = useState('INDIA')

    function fetchValidation() {
        const validationResult = Validator(fieldData.trackedEntityAttribute.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    const noOptionsMessage = (value) => {
        values[fieldData.trackedEntityAttribute.id] = value.inputValue
        setPlaceholder(value.inputValue)
    }

    const onChnage = (value) => {
    console.log('onchange', value)
    Geocode.setApiKey('AIzaSyC1i55hHwdQFdwU1BxXjJpaq7QVqqQjSMg')
    values[fieldData.trackedEntityAttribute.id] = value.label
                            setPlaceholder(value.label)
    geocodeByAddress(value.label)   
        .then(results => getLatLng(results[0]))
        .then(({ lat, lng }) => {
            //setValue(value.label)
            let fieldId = fieldData.trackedEntityAttribute.id
            values[fieldId] = value.label
            let lati = ''
            let lngi = ''
            Geocode.fromAddress(value.label).then(
                response => {
                    const { lat, lng } = response.results[0].geometry.location;
                    lati = lat
                    lngi = lng
                    
                    

                    Geocode.fromLatLng(lat, lng).then(
                        response => {
                            const address = response.results[0].formatted_address;
                            
                            
                            
                            const data = {
                                'value': value,
                                'fieldId': fieldData.trackedEntityAttribute.id,
                                'lat': lat,
                                'lng': lng,
                            }
                            props.onGoogleLocationChange(data) 
                        },
                        error => {
                            console.error(error);
                        }
                    );
                },
                error => {
                    console.error(error);
                }
            );


        }


        );
    }

    useEffect(() => {
        fetchValidation()
    }, [values, placeholder])

    useEffect(() => {
        if (validationResult != null) {
            if(navigator.onLine){

                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? 'customLoc' : 'hide'}>
                        <div>
                        <label>{getTranslatedLabels(fieldData.trackedEntityAttribute)} </label>
                        <GooglePlacesAutocomplete
                            name={fieldData.trackedEntityAttribute.id}
                            key={fieldData.trackedEntityAttribute.id}
                            required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                            validate={composeValidators(required)}
                            apiKey={'AIzaSyC1i55hHwdQFdwU1BxXjJpaq7QVqqQjSMg'}
                            autocompletionRequest={{
                                bounds: [
                                    { lat: 50, lng: 50 },
                                    { lat: 100, lng: 100 }
                                ],

                            }}
                            selectProps={{
                                placeholder: placeholder != null ? placeholder : '',
                                //value,
                                onChange: (value) => onChnage(value),
                                noOptionsMessage: (value) => noOptionsMessage(value)
                            }}
                        />
                        </div>
                    </Grid>
                )
            }else{
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true? 'customLoc' : 'hide'}>
                        <Field
                            name={fieldData.trackedEntityAttribute.id}
                            label={getTranslatedLabels(fieldData.trackedEntityAttribute)}
                            type={'text'}
                            component={InputFieldFF}
                            key={fieldData.trackedEntityAttribute.id}
                            required={fieldData.mandatory && validationResult.hideShow == true ? true : false}
                            validate={composeValidators(required)} //fieldData.mandatory && validationResult.hideShow == true ? hasValue : false
                        />
                    </Grid>
                )
            }
        }

    }, [validationResult])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function CreateField(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let programData = props.programData
    let activeCaseDetails = props.activeCaseDetails
    let linkContactFlag = props.linkContactFlag
    let OUM = OUMapping(values)
    let OUJSON = props.OUJSON
    let Configuration=props.Configuration
    let indexClient = props.indexClient
    //const OUM = OUMapping(values)
    let customVariable=props.customVariable
    let userBO = props.userBO
    
    
    let rules = {
        "programRule": props.programRules,
        "programRuleVariable":props.programRulesVariables
     }

     


    function checkFieldType() {
        const onGoogleLocatioChange = (value) => {
            props.onGoogleLocatioChangeParent(value)
        }
        switch (fieldData.trackedEntityAttribute.valueType) {
            case 'TEXT':
                return fieldData.trackedEntityAttribute.unique
                    ?
                    <DefaultValueField
                        fieldData={fieldData}
                        programRules={programRules}
                        programRulesVariables={programRulesVariables}
                        values={values}
                        linkContactFlag={linkContactFlag}
                    />
                    :
                    (fieldData.renderType && fieldData.renderType['DESKTOP'] && fieldData.renderType['DESKTOP'].type == "QR_CODE") || fieldData.trackedEntityAttribute.id == customVariable.associateQRcodeId ?
                    <QrCodeScanner
                        fieldData={fieldData}
                        programRules={programRules}
                        programRulesVariables={programRulesVariables}
                        values={values}
                    />

                    :
                    fieldData.trackedEntityAttribute.attributeValues 
                        ? fieldData.trackedEntityAttribute.attributeValues[0] 
                            ? fieldData.trackedEntityAttribute.attributeValues[0].attribute.name == 'enableGoogleLocation'
                                ?
                                    <GoogleLocation
                                        fieldData={fieldData}
                                        programRules={programRules}
                                        programRulesVariables={programRulesVariables}
                                        values={values}
                                        linkContactFlag={linkContactFlag}
                                        onGoogleLocationChange = {onGoogleLocatioChange}
                                        
                                    />
                                :
                                <InputFieldConfig
                                    fieldData={fieldData}
                                    programRules={programRules}
                                    programRulesVariables={programRulesVariables}
                                    values={values}
                                    programData={programData}
                                    activeCaseDetails={activeCaseDetails}
                                    linkContactFlag={linkContactFlag}
                                    Configuration={Configuration}
                                    indexClient={indexClient}
                                    customVariable={customVariable}
                                    userBO={userBO}
                                />
                            :
                            <InputFieldConfig
                                fieldData={fieldData}
                                programRules={programRules}
                                programRulesVariables={programRulesVariables}
                                values={values}
                                programData={programData}
                                activeCaseDetails={activeCaseDetails}
                                linkContactFlag={linkContactFlag}
                                Configuration={Configuration}
                                indexClient={indexClient}
                                customVariable={customVariable}
                                userBO={userBO}
                            />    
                            
                    : <InputFieldConfig
                        fieldData={fieldData}
                        programRules={programRules}
                        programRulesVariables={programRulesVariables}
                        values={values}
                        programData={programData}
                        activeCaseDetails={activeCaseDetails}
                        linkContactFlag={linkContactFlag}
                        Configuration={Configuration}
                        indexClient={indexClient}
                        customVariable={customVariable}
                        userBO={userBO}
                    />
                    //case 'COORDINATE':
                        // return <GoogleLocation
                        //     fieldData={fieldData}
                        //     programRules={programRules}
                        //     programRulesVariables={programRulesVariables}
                        //     values={values}
                        //     linkContactFlag={linkContactFlag}
                        // />
            case 'IMAGE':            

            case "FILE_RESOURCE":
                return <ImageFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    
                />


            case 'DATE':
                return <DateFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />

            case 'AGE':
                return <AgeFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />

            case 'PHONE_NUMBER':
                return <PhoneNumberFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />

            case 'EMAIL':
                return <EmailFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />
            case 'BOOLEAN':
            case 'TRUE_ONLY':
                if (programData.programSections.length > 0 &&
                    programData.programSections.filter(
                        (obj) => obj.displayName == fieldData.trackedEntityAttribute.displayName
                    ).length > 0
                ) {
                    const filterDataElementGroup = programData.programSections.filter(
                        (obj) => obj.displayName == fieldData.trackedEntityAttribute.displayName
                    )[0];
                        
                    return (
                        <MultiSelectConfig
                            fieldData={fieldData}
                            programRules={programRules}
                            programRulesVariables={programRulesVariables}
                            values={values}
                            DataElementGroup={filterDataElementGroup}
                            programObj={programData}
                            customVariable={customVariable}
                        />
                    );
                } else {
                    let ShowFieldFlag = false;
                    if (ShowFieldFlag) {
                        return <BooleanFieldConfig
                            fieldData={fieldData}
                            programRules={programRules}
                            programRulesVariables={programRulesVariables}
                            values={values}
                        />
                    } else {
                        return <> </>;
                    }
                    // return <BooleanFieldConfig
                    //     fieldData={fieldData}
                    //     programRules={programRules}
                    //     programRulesVariables={programRulesVariables}
                    //     values={values}
                    // />
                }
            // case 'TRUE_ONLY':
            //     return <BooleanFieldConfig
            //         fieldData={fieldData}
            //         programRules={programRules}
            //         programRulesVariables={programRulesVariables}
            //         values={values}
            //     />
            case 'TIME':
                return <TimeFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />

            case 'DATETIME':
                return <DateTimeFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />

            case 'INTEGER':
            case 'INTEGER_POSITIVE':
            case 'INTEGER_NEGATIVE':
            case 'INTEGER_ZERO_OR_POSITIVE':
            case 'NUMBER':
                return <IntegerConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    customVariable={customVariable}
                />
            case 'LONG_TEXT':
                return <TextAreaConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />

            case 'USERNAME':
                return <UserNameConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />

            case 'URL':
                return <URLConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                />

            case 'ORGANISATION_UNIT':
                const defaultValue = values[fieldData.trackedEntityAttribute.id]
                
                let optionsId = ''
                let defaultOption = {}
                const childDropDown = JSON.parse(localStorage.getItem('childDropDown'))
                    if (childDropDown != null) {
                        const fieldOptionFilter = childDropDown.filter(obj => obj.fieldId == fieldData.trackedEntityAttribute.id)
                        if (fieldOptionFilter.length > 0) {
                            optionsId = fieldOptionFilter[0].value
                        }

                    }
                if (defaultValue != undefined) {
                    

                    const LocationFilter = programData.organisationUnits.filter(OU => OU.id == values[fieldData.trackedEntityAttribute.id])
                    const locationName = LocationFilter.length > 0 ? LocationFilter[0].displayName : ""
                    defaultOption = {
                        'id': values[fieldData.trackedEntityAttribute.id],
                        'label': locationName ? locationName : values[fieldData.trackedEntityAttribute.id],
                        'value': values[fieldData.trackedEntityAttribute.id]
                    }

                    if (OUM[fieldData.trackedEntityAttribute.id] != undefined) {
                        if (OUM[fieldData.trackedEntityAttribute.id].parent != '') {
                            optionsId = values[OUM[fieldData.trackedEntityAttribute.id].parent]
                        }
                    }
                    
                }
                 //LocationFilter, locationName optionsId, defaultValue,
                //if(optionsId != '') {
                    
                    return <HandleOUOptions
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    programData={programData}
                    options={optionsId} 
                    defaultOption={defaultOption}
                    OUMapping ={OUM}
                    OUJSON = {OUJSON}
                    />
                 

        }
    }


    return (
        <>
            {checkFieldType()}
        </>

    )
}

export default CreateField;
